import { withLoader } from '@app/helpers/withLoader';
import { lazy } from 'react';
export default withLoader(lazy(() => import('./Layout')));
